import { NgClass } from '@angular/common';
import { Component, Input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentBrand } from '@core/tellent-types';
import type { ArrowPosition } from '@core/user-interface-legacy';
import {
  BadgeComponent,
  BaseTooltipComponent,
  ButtonComponent,
  IconButtonComponent,
  PreventOrphansPipe,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-feature-tooltip',
  templateUrl: './feature-tooltip.component.html',
  styleUrls: ['./feature-tooltip.component.less'],
  imports: [
    NgClass,
    BadgeComponent,
    IconButtonComponent,
    ButtonComponent,
    TranslatePipe,
    PreventOrphansPipe,
  ],
  host: {
    '[class]': 'brand',
  },
})
export class FeatureTooltipComponent extends BaseTooltipComponent {
  public readonly TellentBrand = TellentBrand;

  @Input() public isNew: boolean;
  @Input() public title: string;
  @Input() public description: string;
  @Input() public ctaText?: string;
  @Input() public learnMore?: string;
  @Input() public learnMoreCopy?: string;
  @Input() public arrowPosition: ArrowPosition;
  @Input() public brand?: TellentBrand = TellentBrand.Recruitee;

  public learnMoreClick = output<void>();
  public ctaClick = output<void>();
  public close = output<void>();

  public ngOnChanges(): void {
    this.updateArrow(this.arrowPosition);
  }
}
